import React from 'react';

import { ClassThemeProvider } from '@class-ui/theme';

import { ClassContainer } from './ClassContainer';
import ClassForm from './ClassForm';

const ClassModal = () => (
    <ClassThemeProvider>
        <ClassContainer.Provider>
            <ClassForm />
        </ClassContainer.Provider>
    </ClassThemeProvider>
);

export default ClassModal;
